import SettingsCard from './SettingsCard'

export default SettingsCard
